// extracted by mini-css-extract-plugin
export var avatarContainer = "_4k-0";
export var gray = "_4k-f";
export var green = "_4k-c";
export var icon = "_4k-9";
export var image = "_4k-1";
export var lg = "_4k-6";
export var md = "_4k-5";
export var presenceDot = "_4k-b";
export var red = "_4k-d";
export var sm = "_4k-4";
export var status = "_4k-a";
export var xl = "_4k-7";
export var xs = "_4k-3";
export var xxl = "_4k-8";
export var xxs = "_4k-2";
export var yellow = "_4k-e";